import { format } from "date-fns";

declare var Tafgeet: any;

let numericalKeys = {
  3: "ثلاثة",
  4: "اربعة",
  5: "خمسة",
  6: "ستة",
  7: "سبعة",
  8: "ثمانية",
  9: "تسعة",
  10: "عشرة",
  11: "احد عشر",
  12: "اثنى عشر",
};

let keys = {
  mon_1: "شهر",
  mon_2: "شهرين",
  mon_multi: "اشهر",
  yer_1: "سنه",
  yer_2: "سنتين",
  yer_multi: "سنوات",
};

function ParseMonthCount(value) {
  value = Number(value);
  if (value === 1) {
    return keys.mon_1;
  } else if (value === 2) {
    return keys.mon_2;
  } else if (value > 2 && value <= 10) {
    return numericalKeys[value] + " " + keys.mon_multi;
  } else if (value > 10) {
    return numericalKeys[value] + " " + keys.mon_1;
  }
}

function ParseYearCount(value) {
  value = Number(value);
  if (!Number.isInteger(value)) {
    const intPart = Math.floor(value);
    const decimalPart = Math.floor((value - intPart) * 12);
    if (intPart === 1) {
      return keys.yer_1 + " و " + ParseMonthCount(decimalPart);
    } else if (intPart === 2) {
      return keys.yer_2 + " و " + ParseMonthCount(decimalPart);
    } else if (intPart > 2 && intPart <= 10) {
      return (
        numericalKeys[intPart] +
        " " +
        keys.yer_multi +
        " و " +
        ParseMonthCount(decimalPart)
      );
    } else if (intPart > 10) {
      return (
        numericalKeys[intPart] +
        " " +
        keys.yer_1 +
        " و " +
        ParseMonthCount(decimalPart)
      );
    }
  } else {
    if (value === 1) {
      return keys.yer_1;
    } else if (value === 2) {
      return keys.yer_2;
    } else if (value > 2 && value <= 10) {
      return numericalKeys[value] + " " + keys.yer_multi;
    } else if (value > 10) {
      return numericalKeys[value] + " " + keys.yer_1;
    }
  }
}

export const printEOIDetailsFile = ({ base, system }, eoi: any = {}) => {
  // constants
  const layout: any = {
    letterhead: "ww-letterhead.png",
  };

  console.log(eoi);

  const logo = eoi.project.installment_logo.url;

  const today = new Date().toISOString().slice(0, 10);

  function formatCurrency(amount) {
    return amount.toLocaleString("en-US");
  }

  const selling_date = format(new Date(eoi.selling_date), "dd/MM/yyyy");

  return `<!DOCTYPE html>
  <html lang="ar" dir="rtl">
    <head>
      <meta charset="UTF-8" />
      <meta http-equiv="X-UA-Compatible" content="IE=edge" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>EOI Details</title>


      <style>
        @font-face {
          font-family: "Cairo";
          src: url(${base}assets/fonts/Cairo-VariableFont_slnt,wght.ttf);
        }

        body {
          font-size: 12pt;
          background-image: url();
          font-family: "Cairo";
          background-size: 100vw 100vh;
          line-height: 1.7rem;
        }
        pre {
          font-family: "Cairo";
        }

        .sm-text {
          font-size: 10pt !important;
        }

        h3, h4{
          margin: 0.7rem 0 !important;
        }

        .ml-3{
          margin-inline-end: 3rem !important;
        }

        .ml-1{
          margin-inline-end: 0.5rem !important;
        }

        .mr-3{
          margin-inline-start: 0.5rem !important;
        }

        .mt-3{
          margin-top: 0.7rem !important;
        }

        .mt-6{
          margin-top: 2.5rem !important;
        }
          
        .mt-6{
          margin-top: 1.5rem !important;
        }

        .font-bold{
          font-weight: bold;
        }

        .text-center{
          text-align:center;
        }

        .p{
          line-height: 1.4rem;
        }

        .p1{
          line-height: 1.8rem;
        }
        
        .p2{
          line-height: 1.8rem;
        }

        .ltr {
          direction: ltr !important;
        }

        /* table classes */
        .table {
          width: 100%;
          margin-bottom: 1rem;
          color: #212529;
          border-collapse: collapse;
        }

        .table-bordered {
          border: 1px solid #dee2e6;
        }

        .table-bordered th,
        .table-bordered td {
          padding: 0.25rem 2rem !important;
          border: 1px solid #dee2e6;
          text-align: center;
          white-space: nowrap;
        }

        /* Flex utilities */
        .d-flex, .flex {
          display: flex;
        }
        
        .flex-row{
          flex-direction: row;
        }

        .flex-col{
          flex-direction: column;
        }

        .flex-column{
          flex-direction: column;
        }

        .gap-4 {
          gap: 1.5rem;
        }

        .justify-content-center {
          justify-content: center;
        }

        .justify-content-end {
          justify-content: flex-end;
        }

        .justify-content-start {
          justify-content: flex-start;
        }

        .justify-content-between {
          justify-content: space-between;
        }

        .align-items-center {
          align-items: center;
        }

       .flex-wrap{
          flex-wrap: wrap;
        }


        .underline{
          text-decoration: underline;
        }

        .justify-content-evenly {
          justify-content: space-evenly;
        }

        .justify-content-around {
          justify-content: space-around;
        }

        .w-100{
          width: 100% !important;
        }

        .w-33{
          width: 33.333% !important;
        }

        .w-50{
          width: 50% !important;
        }

        .container {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
        }

        .item {
          flex: 0 0 calc(50% - 8px);
          box-sizing: border-box;
          padding-bottom: 20px;
        }

        /* custom */

        @media print {
          * {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }

          footer {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
          }

          .page {
            position: relative;
            padding-right: 1.5rem;
            padding-left: 1.5rem;
            max-height: 95vh;
            min-height: 94vh;
            page-break-inside: avoid;
            page-break-before: avoid;
            page-break-after: always;
          }
        }
          
        @page {
          size: A4 portrait;
        }
      </style>
    </head>
    <body>
      <div class="page p2">
        <div class="w-100 mt-6 ltr">
          <img src="${logo}" alt="logo" width="200" />
        </div>
        <div class="w-100">
          <h2 class="text-center underline">
            إستمـارة طلب حـجـز
          </h2>
        </div>
        <div class="w-100">
            <span class="font-bold ml-1">
                التاريخ:
            </span>
            <span></span>
                ${today}
            </span>
        </div>
        <div class="w-100 flex align-items-center justify-content-center">
            <span class="font-bold ml-1">
                نموذج رقم:
            </span>
            <span>
                ${eoi.serial}
            </span>
        </div>
        <div class="w-100 flex flex-col justify-content-start gap-4">
            <div class="w-100">
                <span class="ml-1">
                    الاسم بالكامل :
                </span>
                <span>
                    ${eoi.lead_name}
                </span>
            </div>
            <div class="w-100 flex flex-row gap-4 justify-content-start">
                <div>
                    <span class="ml-1">
                        الرقم القومي / رقم جواز السفر:
                    </span>
                    ${
                      eoi.lead_national_id
                        ? `
                            <span>
                                ${eoi.lead_national_id}
                            </span>
                         `
                        : "..........................."
                    }
                </div>
                <div>
                    <span class="ml-1">
                        الجنسية:
                    </span>
                    ${
                      eoi.lead_nationality
                        ? `
                            <span>
                                ${eoi.lead_nationality}
                            </span>
                         `
                        : "..........................."
                    }
                </div>
            </div>
        </div>
        <div class="w-100 flex flex-row gap-4 justify-content-start">
            <div>
                <span class="ml-1">
                    رقم الهاتف:
                </span>
                ${
                  eoi.lead_phone
                    ? `
                        <span>
                            ${eoi.lead_phone}
                        </span>
                     `
                    : "..........................."
                }
            </div>
            <div>
                <span class="ml-1">
                    البريد الالكتروني::
                </span>
                ${
                  eoi.lead_email
                    ? `
                        <span>
                            ${eoi.lead_email}
                        </span>
                     `
                    : "..........................."
                }
            </div>
        </div>
        <div class="w-100">
            <span class="font-bold ml-1">
                العنوان:
            </span>
            <span>
                ${eoi.lead_address}
            </span>
        </div>
        <div class="w-100">
            <span class="font-bold ml-1">
                تفاصيل الطلب:
            </span>
        </div>
        <div class="w-100">
          <span class="font-bold ml-1">
              سدد العميل مبلغ وقدره:
          </span>
          ${
            eoi.eoi_price
              ? `
                  <span>
                      ${formatCurrency(Number(eoi.eoi_price))} جنيه</span>
                      <span class="mr-3 sm-text">
                        (${new Tafgeet(eoi.eoi_price).parse(
                          false
                        )} جنيه فقط لاغير)
                  </span>
                 `
              : "..........................."
          }
        </div>
        ${
          eoi.payment_type
            ? `
                <div class="w-100">
                  <span class="font-bold ml-1">
                      طريقة السداد:
                  </span>
                  <span>
                      ${eoi.payment_type}
                  </span>
                </div>
              `
            : ""
        }
        ${
          eoi.cheque_number
            ? `
                <div class="w-100">
                  <span class="font-bold ml-1">
                      رقم الشيك:
                  </span>
                  <span>
                      ${eoi.cheque_number}
                  </span>
                </div>
              `
            : ""
        }
        <div class="w-100">
          <span class="font-bold ml-1">
            كطلب حجز لشراء وحدة بمشروع
          </span>
          <span class="font-bold ml-1">
            ${eoi.project.name}
          </span>
          <span class="font-bold ml-1">
            بالمواصفات الاتية:
          </span>
        </div>
        ${eoi.details.map((detail) => {
          return `
                ${
                  detail.generic_type
                    ? `
                    <div class="w-100">
                      ${
                        detail.generic_type == "Administrative"
                          ? `<span class="ml-1">  مكتب اداري:مساحة من</span>`
                          : ""
                      }
                      ${
                        detail.generic_type == "Commercial"
                          ? `<span class="ml-1">  تجاري:مساحة من</span>`
                          : ""
                      }
                      ${
                        detail.generic_type == "Residential"
                          ? `<span class="ml-1">  سكني: مساحة من</span>`
                          : ""
                      }
                      <span>
                          ${detail.interested_area_from}
                      </span>
                      <span>
                          الي ${detail.interested_area_to}
                      </span>
                      ${
                        detail.generic_type == "Administrative"
                          ? `<span class="ml-1">
                                النشاط:
                                ${detail.unit_type}
                             </span>`
                          : ""
                      }
                    </div>
                    `
                    : ""
                }`;
        })}

        <div class="mt-3 d-flex flex-column">
          <h3 class="font-bold mt-3"> الشروط والاحكام:</h3>
          <ul class="mt-3">
            <li>
                هذه الاستمارة لا تعد اتفاق أو وعد بحجز وحدة محددة للعميل.
            </li>
            <li>
                هذه الاستمارة تعد مجرد نموذج طلب حجز من العميل للحصول على فرصة لاختيار وحدة مناسبة في التاريخ المعلن عنه طبقا لرقم النموذج.
            </li>
            <li>
                المبلغ المدفوع مسترد بالكامل في حالة عدم إيجاد العميل لوحدة مناسبة خلال الطرح.
            </li>
            <li>
                المبلغ المدفوع سيتم خصمه من اجمالي الوحدة المختارة عند التعاقد.
            </li>
            <li>
                يملك العميل الفرصة في اختيار او شراء أكثر من وحدة بنفس المواصفات المذكورة في الاستمارة.
            </li>
            <li>
                بتوقيع هذه الاستمارة يقر العميل بعدم تحويل رقم هذه الاستمارة لغيره بخلاف الاقرباء من الدرجة الأولي.
            </li>
            <li>
                هذه الاستمارة تعد اثبات ورقي بأن العميل قد دفع المبلغ المذكور أعلاه
            </li>
          </ul>
          <div class="w-100 mt-3">
              <h3 class="font-bold">توقيعات الإقرار :</h3>
          </div>
          <div class="d-flex justify-content-around">
            <div>
              <h3 class=""> اسم العميل</h3>
              <p>.................................................</p>
            </div>
            <div>
              <h3 class="">ممثل المبيعات</h3>
              <p>.................................................</p>
            </div>
            <div>
              <h3 class="">مدير المبيعات</h3>
              <p>.................................................</p>
            </div>
          </div>
        </div>


      </div>
    </body>
  </html>
  `;
};



// WEBPACK FOOTER //
// ./src/app/eois/eoi-view/prints/eoi_print.ts